import {
	Component,
	OnInit,
	HostBinding,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy
} from '@angular/core';
import { LayoutConfigService } from '../../../../config/_core/services/layout-config.service';
import * as objectPath from 'object-path';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../pages/auth/_core/services/authentication.service';
import { SessionKeys } from '../../../pages/auth/_core/services/token-storage.service';

@Component({
	selector: 'm-topbar',
	templateUrl: './topbar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopbarComponent implements OnInit, AfterViewInit {
	@HostBinding('id') id = 'm_header_nav';
	@HostBinding('class')
	classes = 'm-stack__item m-stack__item--fluid ';
	usuarioName: string;
	@Input() searchType: any;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private authService: AuthenticationService,
		private router: Router
	) {
		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;
			this.searchType = objectPath.get(config, 'header.search.type');
		});
	}

	ngOnInit(): void {
		this.usuarioName = this.authService.getDatoSession(SessionKeys.NOMBRE);
	}

	ngAfterViewInit(): void {}
}
